import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "../FundraiserWidget.module.scss";
interface BankTransferPaneProps {
  kid: string | null;
  showBankInfo: boolean;
  bankDetails: {
    account_number_prefix: string;
    account_number: string;
    kid_prefix: string;
    transfer_delay_text: string;
    account_owner_text: string;
    bank_transfer_info: string;
  } | undefined;
  className?: string;
  visible?: boolean;
}
export const BankTransferPane = React.forwardRef<HTMLDivElement, BankTransferPaneProps>((t0, ref) => {
  const $ = _c(49);
  const {
    kid,
    showBankInfo,
    bankDetails,
    className,
    visible
  } = t0;
  let t1;
  if ($[0] !== bankDetails) {
    t1 = template => template.replace(/\{(\w+)\}/g, (match, key) => {
      if (key === "accountNumber" && bankDetails?.account_number) {
        return bankDetails.account_number;
      }
      return match;
    });
    $[0] = bankDetails;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const parseTemplate = t1;
  if (!showBankInfo || !bankDetails) {
    const t2 = visible ? "block" : "none";
    let t3;
    if ($[2] !== t2) {
      t3 = {
        display: t2
      };
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== className || $[5] !== ref || $[6] !== t3) {
      t4 = <div ref={ref} className={className} style={t3} data-cy="fundraiser-pane-bank" />;
      $[4] = className;
      $[5] = ref;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  }
  const t2 = visible ? "block" : "none";
  let t3;
  if ($[8] !== t2) {
    t3 = {
      display: t2
    };
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== bankDetails.bank_transfer_info || $[11] !== parseTemplate) {
    t4 = parseTemplate(bankDetails.bank_transfer_info);
    $[10] = bankDetails.bank_transfer_info;
    $[11] = parseTemplate;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <p>{t4}</p>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== bankDetails.account_number_prefix) {
    t6 = <strong>{bankDetails.account_number_prefix}</strong>;
    $[15] = bankDetails.account_number_prefix;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== bankDetails.account_number || $[18] !== t6) {
    t7 = <p>{t6} {bankDetails.account_number}</p>;
    $[17] = bankDetails.account_number;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== bankDetails.kid_prefix) {
    t8 = <strong>{bankDetails.kid_prefix}</strong>;
    $[20] = bankDetails.kid_prefix;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== kid || $[23] !== t8) {
    t9 = <p data-cy="fundraiser-kid">{t8} {kid}</p>;
    $[22] = kid;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t7 || $[26] !== t9) {
    t10 = <div className={styles["donation-widget__account-info"]} data-cy="fundraiser-account-info">{t7}{t9}</div>;
    $[25] = t7;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== bankDetails.transfer_delay_text || $[29] !== parseTemplate) {
    t11 = parseTemplate(bankDetails.transfer_delay_text);
    $[28] = bankDetails.transfer_delay_text;
    $[29] = parseTemplate;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11) {
    t12 = <p>{t11}</p>;
    $[31] = t11;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      paddingBottom: "2rem"
    };
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== bankDetails.account_owner_text || $[35] !== parseTemplate) {
    t14 = parseTemplate(bankDetails.account_owner_text);
    $[34] = bankDetails.account_owner_text;
    $[35] = parseTemplate;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t14) {
    t15 = <p style={t13}>{t14}</p>;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t10 || $[40] !== t12 || $[41] !== t15 || $[42] !== t5) {
    t16 = <div className={styles["donation-widget__form"]} data-cy="fundraiser-bank-details">{t5}{t10}{t12}{t15}</div>;
    $[39] = t10;
    $[40] = t12;
    $[41] = t15;
    $[42] = t5;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== className || $[45] !== ref || $[46] !== t16 || $[47] !== t3) {
    t17 = <div ref={ref} className={className} style={t3} data-cy="fundraiser-pane-bank">{t16}</div>;
    $[44] = className;
    $[45] = ref;
    $[46] = t16;
    $[47] = t3;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  return t17;
});
BankTransferPane.displayName = "BankTransferPane";